import getFirebase from '../lib/firebase';

const SERVER_API_URL = process.env.GATSBY_SERVER_API_URL;
const SERVER_API_KEY = process.env.GATSBY_SERVER_API_KEY;

// Return a currently-valid Firebase ID token for the signed-in user, or null if
// there is no user / Firebase isn't ready. getIdToken() serves the cached token
// while it's valid and transparently mints a fresh one from the long-lived
// refresh token once it has expired, so authenticated requests never carry an
// expired token and the user is never forced to sign in again. Failures resolve
// to null rather than throwing, so a transient issue surfaces as an
// unauthenticated request (the API answers 401) instead of breaking the call.
const getFreshIdToken = async () => {
    if (typeof window === 'undefined') {
        return null;
    }

    try {
        const firebase = getFirebase();
        const user = firebase && firebase.auth().currentUser;
        if (!user) {
            return null;
        }

        return await user.getIdToken();
    } catch (error) {
        console.error('getFreshIdToken error: ', error);
        return null;
    }
};

// Set `authenticated: true` for endpoints that require a signed-in member;
// ApiFetch attaches a fresh Firebase ID token automatically. An explicit
// `userToken` still wins, for the rare caller that already holds one.
const ApiFetch = async ({ path, method = 'GET', body = null, authenticated = false, userToken = null }) => {
    try {
        const params = {
            method,
            headers: {
                "Content-Type": "application/json",
                Accept: 'application/json',
                Authorization: `Bearer ${SERVER_API_KEY}`
            },
        };

        const token = userToken || (authenticated ? await getFreshIdToken() : null);
        if (token) {
            params.headers.token = token;
        }

        if (body) {
            params.body = JSON.stringify(body);
        }

        const result = await fetch(`${SERVER_API_URL}${path}`, params)
            .then((response) => response.json());

        return result;

    } catch (error) {
        console.error("error: ", error);
        throw new Error(`Error on ApiFetch ${error.message}`);
    }
};

export default ApiFetch;
